
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/solutions",
      function () {
        return require("private-next-pages/[locale]/solutions.tsx");
      }
    ]);
  